import React, { createContext, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useAgentPanel } from './hooks/useAgentPanel'

const AgentPanelStableContext = createContext(null)
const AgentPanelDynamicContext = createContext(null)

export function AgentPanelProvider ({ workspaceContext, onApplyProposal, children }) {
  const panel = useAgentPanel('eval-designer', { workspaceContext })
  const [autoAccept, setAutoAccept] = useState(false)

  const stable = useMemo(() => ({
    addMessage: panel.addMessage,
    cancelThread: panel.cancelThread,
    isCancelling: panel.isCancelling,
    config: panel.config,
    onApplyProposal,
    autoAccept,
    setAutoAccept
  }), [panel.addMessage, panel.cancelThread, panel.isCancelling, panel.config, onApplyProposal, autoAccept])

  const dynamic = useMemo(() => ({
    messages: panel.messages,
    agentStatus: panel.agentStatus,
    processingMessage: panel.processingMessage,
    isThreadLoading: panel.isThreadLoading,
    isErrored: panel.isErrored,
    errorMessage: panel.errorMessage,
    threadId: panel.threadId,
    threadData: panel.threadData,
    workspaceContext
  }), [
    panel.messages, panel.agentStatus, panel.processingMessage, panel.isThreadLoading,
    panel.isErrored, panel.errorMessage, panel.threadId, panel.threadData,
    workspaceContext
  ])

  return (
    <AgentPanelStableContext.Provider value={stable}>
      <AgentPanelDynamicContext.Provider value={dynamic}>
        {children}
      </AgentPanelDynamicContext.Provider>
    </AgentPanelStableContext.Provider>
  )
}

AgentPanelProvider.propTypes = {
  workspaceContext: PropTypes.object,
  onApplyProposal: PropTypes.func,
  children: PropTypes.node
}

export function useAgentPanelContext () {
  const stable = useContext(AgentPanelStableContext)
  const dynamic = useContext(AgentPanelDynamicContext)
  if (!stable || !dynamic) {
    throw new Error('useAgentPanelContext must be used within an AgentPanelProvider')
  }
  return { ...stable, ...dynamic }
}
